var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{style:(`--order:${_vm.order?.header ?? 99}`)},[(_vm.title !== 'Independent')?_c('span',{staticClass:"menu-label is-bolder"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('ul',_vm._l((_vm.routes),function(route,j){return _c('NavigationItem',{key:`item-${j}`,attrs:{"route":route,"item-order":_vm.order?.items[route.text] ?? 99}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }